<template>
    <div class="banner_warning_message" @click="openWarningMessageModal">
        <span class="btn__warning_message">{{ $t('warningMessage') }}</span>

        <Modal :title="$t('warningMessage')" :modal-name="modalId">{{ message }}</Modal>
    </div>
</template>

<script lang="ts">
import Modal from '~/components/Modal.vue'

export default {
    name: 'WarningMessageInBanner',
    components: { Modal },
    props: {
        modalId: {
            type: String,
            default: 'BannerWarningMessageModal',
        },
        message: {
            type: String,
            required: true,
        },
    },
    methods: {
        openWarningMessageModal() {
            useNuxtApp().$bus.$emit('showModal', this.modalId)
        },
    },
}
</script>

<style lang="scss" scoped>
.banner_warning_message {
    position: absolute;
    bottom: 25px;
    left: 0;
    z-index: 10;

    @media (max-width: 480px) {
        bottom: 35px;
    }

    .btn__warning_message {
        cursor: pointer;
        background: $color-white-opacity;
        padding: 3px 7px;
        font-size: 14px;
    }
}
</style>
